// extracted by mini-css-extract-plugin
export default {"link":"qBTvo","menuName":"f3lir","arrow":"yKPuM"};